import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
  timeout: 60000,
});

apiClient.interceptors.request.use((config) => {
  const nextConfig = { ...config };
  const existingAuthHeader = nextConfig.headers?.Authorization || nextConfig.headers?.authorization;
  if (existingAuthHeader) return nextConfig;

  try {
    const authState = JSON.parse(localStorage.getItem('hbfurniture_auth') || '{}');
    const token = authState?.user?.token;
    if (token) {
      nextConfig.headers = {
        ...(nextConfig.headers || {}),
        Authorization: `Bearer ${token}`,
      };
    }
  } catch {
    // no-op
  }

  return nextConfig;
});

export const apiCall = async ({ method = 'GET', url, data, params, headers }) => {
  const response = await apiClient({ method, url, data, params, headers });
  return response.data;
};

export default apiClient;
